import { COLOR } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const SpanText = styled.span`
  vertical-align: middle;
  color: ${COLOR.GRAY900.code};
  font-size: 12.5px;
`;
